import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv1015GetResultModel, Inv1015GetResultSchema } from './get.schema'

export async function fetchInv1015(id: number): Promise<Inv1015GetResultModel> {
  const response = await axios.get<Inv1015GetResultModel>(
    `/api/warehouse/inv1015/${id}`
  )
  return Inv1015GetResultSchema.parse(response.data)
}

export const getInv1015ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv1015', id],
    queryFn: () => fetchInv1015(id),
  })
